/** Expliciete markering voor pagina's die nog niet zijn overgezet. */
export function Placeholder({ name }: { name: string }) {
  return (
    <div className="panel">
      <div className="head">
        <div>
          <h3>{name}</h3>
          <p>Not migrated to v2 yet</p>
        </div>
      </div>
      <div className="body">
        <div className="note">
          This page is still in the old bundle. See
          <code> /root/dashboard-inventaris.md </code> for the checklist and
          <code> /root/dashboard-v2-progress.md </code> for progress.
        </div>
      </div>
    </div>
  )
}
